module.exports = __webpack_public_path__ + "img/special2.1f3b640e.png";